export const FETCH_ALLEXAMS_RESULT_REQUEST = 'FETCH_ALLEXAMS_RESULT_REQUEST'
export const FETCH_ALLEXAMS_RESULT_SUCCESS = 'FETCH_ALLEXAMS_RESULT_SUCCESS'
export const FETCH_ALLEXAMS_RESULT_FALIURE = 'FETCH_ALLEXAMS_RESULT_FALIURE'
